import { Component, h, Host } from '@stencil/core';

@Component({
  tag: 'uui-theme-swatch',
  styleUrl: 'uui-theme-swatch.css',
  shadow: true
})
export class UuiThemeSwatch {
  render() {
    const coreColors = paletteRange('core');
    const onCoreColors = paletteRange('on-core');
    const errorColors = paletteRange('error');
    const warningColors = paletteRange('warning');
    const successColors = paletteRange('success');
    const secondaryColors = paletteRange('secondary');
    const onSecondaryColors = paletteRange('on-secondary');
    const variantColors = paletteRange('variant');
    const tertiaryColors = paletteRange('tertiary');
    const otherColors = [
      'background',
      'surface',
      'error',
      'on-core',
      'on-secondary',
      'on-background',
      'on-surface',
      'on-error',
      'on-variant'
    ];
    const swatchSections = [];
    for (const colors of [
      coreColors,
      onCoreColors,
      secondaryColors,
      onSecondaryColors,
      errorColors,
      warningColors,
      successColors,
      variantColors,
      tertiaryColors,
      otherColors
    ]) {
      swatchSections.push(swatchSection(colors));
    }
    return (
      <Host>
        <div>{swatchSections}</div>
      </Host>
    );
  }
}

function swatchSection(colors) {
  const swatches = [];
  for (const themeColor of colors) {
    const backgroundColor = `var(--uui-theme-${themeColor})`;
    swatches.push(
      <div class="swatch" style={{ backgroundColor }}>
        <div>{themeColor}</div>
      </div>
    );
  }
  return <div class="swatch-section">{swatches}</div>;
}

function paletteRange(name: string): string[] {
  const colors = [];
  for (let i = 900; i > 0; i -= 100) {
    colors.push(`${name}-${i}`);
  }
  return colors;
}
